export enum ConnectedForms {
  COUNTRY = 'country',
  STATE = 'state',
}

export const UNITED_STATES = 'United States';

export interface BillingAddressFormObj {
  [BillingAddressFormFields.Street]: string;
  [BillingAddressFormFields.City]: string;
  [BillingAddressFormFields.Country]: string;
  [BillingAddressFormFields.State]: string;
  [BillingAddressFormFields.ZipCode]: string;
  [BillingAddressFormFields.Email]?: string;
}

export enum BillingAddressFormFields {
  Street = 'street',
  Country = 'country',
  State = 'state',
  City = 'city',
  ZipCode = 'zipCode',
  Email = 'email',
}
